import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const updateFormFieldsData = createAsyncThunk(
  "DocsLibrary/updateFormFieldsData",
  async (data, thunkAPI) => {
    try {
      const resp = await axios.put(
        `${process.env.REACT_APP_BASE_URL}api/docs/library/forms/${data.form_id}/fields/${data.field_id}`,
        data.updateData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (data?.handleSuccess) {
        data.handleSuccess();
      }
      return resp.data;
    } catch (error) {
      if (error.response) {
        if (data?.handleError)
          data.handleError(
            error.response.data.errorMessage || error.response.data.message
          );
        return thunkAPI.rejectWithValue(
          error.response.data.errorMessage || error.response.data.message
        );
      } else {
        if (data?.handleError) data.handleError(error.message);
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
